module.exports = __webpack_public_path__ + "static/media/HB_tempehpotatoes_square_forweb.733fe11b.jpg";